const selectDog = (e) => {
    const option = $(`#${e.target.value}`)
    let weight = option.attr('data-dog-weight')
    let age = option.attr('data-dog-birth')

    if (weight) {
        weight = parseInt(weight)
    }

    if (age) {
        age = new Date(age).getFullYear()
        age = new Date().getFullYear() - age
    }

    const variants = $('.productSection__variantOption').map(function (idx, ele) {
        return {
            value: $(ele).val(),
            maxWeight: parseInt($(ele).attr('data-max-weight')),
            minWeight: parseInt($(ele).attr('data-min-weight')),
            maxAge: parseInt($(ele).attr('data-max-age')),
            minAge: parseInt($(ele).attr('data-min-age')),
        };
    }).get();

    variants.shift()

    const weightFilter = variants.filter(({ maxWeight,
        minWeight }) => {
        maxWeight = maxWeight || 200
        minWeight = minWeight || 0

        if (weight <= maxWeight && weight >= minWeight) {
            return true
        }

        return false

    })

    const selectedVariant = weightFilter.find(({
        maxAge,
        minAge }) => {

        maxAge = maxAge || 200
        minAge = minAge || 0
        if (age <= maxAge && age >= minAge) {
            return true
        }

        return false
    })

    let selected = weightFilter[0]?.value || "0"

    if (selectedVariant) {
        selected = selectedVariant.value
    }

    $('.productSection__form .productSection__variantSelect').each(function () {
        $(this).val(selected)
        $('.productSection__form').trigger('change')
    })

}


const dogSelector = $('#product_select-dog-wrapper')
dogSelector.on('change', selectDog)

const fetchDogs = async () => {
// debugger;
    $('#product_select-dog-wrapper svg').removeClass('hidden')
    const customerEmail = $('#product-details-section').attr('data-customer-email') 
    if (customerEmail) {
        const result = await fetch('https://faas-fra1-afec6ce7.doserverless.co/api/v1/namespaces/fn-51a8d90f-14b0-4d31-9524-92fbaa5a51b4/actions/boosa/get-dogs-new?blocking=true&result=true',
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": "Basic ZWMyYTZmNWQtYjZjZC00YjkwLWE0ODYtNjBlODVmZTZhNmU0OmlweWw4UEdKS2NTcFZ2RVdKMW11SVBDbDNKWHNkWUtoT0thYzdjSXQ4UG5LTHVRRkJhS1RTUXRNaE1UUmZWdWk=",
                },
                body: JSON.stringify({ email: customerEmail })
            });
        result.json().then((response) => {
        
            if (response.status === 200) {
                if (response.data.length > 0) {
                    response.data.map((dog, index) => {
                        $('#productSection__dogSelect').append(`<option id="${dog._id}" class="productSection__dogOption p" value="${dog._id}" data-dog-weight="${dog.weight}" data-dog-birth="${dog.birthday}" selected={${index == 0}}>
                                ${dog.name}
                            </option>
                        `);

                        selectDog({ target: { value: dog._id } })
                    });

                    $('#product_select-dog-wrapper .product_variant--background').removeClass('hidden')
                    $('#product_select-dog-wrapper svg').addClass('hidden')

                } else {
                    $('#product_select-dog-wrapper .product_variant--background').addClass('hidden')
                    $('#product_select-dog-wrapper svg').addClass('hidden')
                }
            }
        })
    }
}

fetchDogs()